/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Cap_Jpc_RejectInputs */

const es_cap_jpc_reject = /** @type {(inputs: Cap_Jpc_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rechazar`)
};

const gl_cap_jpc_reject = /** @type {(inputs: Cap_Jpc_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rexeitar`)
};

const en_cap_jpc_reject = /** @type {(inputs: Cap_Jpc_RejectInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Decline`)
};

/**
* | output |
* | --- |
* | "Decline" |
*
* @param {Cap_Jpc_RejectInputs} inputs
* @param {{ locale?: "es" | "gl" | "en" }} options
* @returns {LocalizedString}
*/
export const cap_jpc_reject = /** @type {((inputs?: Cap_Jpc_RejectInputs, options?: { locale?: "es" | "gl" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cap_Jpc_RejectInputs, { locale?: "es" | "gl" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "gl") return gl_cap_jpc_reject(inputs)
	if (locale === "en") return en_cap_jpc_reject(inputs)
	return es_cap_jpc_reject(inputs)
});